(function () {
  'use strict';
  function init() {
    var root = document.getElementById('bi-bundle-product');
    if (!root || root.dataset.bpReady) return;
    var configNode = root.querySelector('[data-bp-config]'), cfg;
    try { cfg = JSON.parse(configNode.textContent); } catch (e) { return; }
    root.dataset.bpReady = 'true';
    var DATA = window.BABY_BUNDLE_DATA || {}, S = cfg.strings || {};
    var p = (DATA.products || []).find(function (item) { return String(item.id) === String(cfg.id); });
    var variants = cfg.variants || [], mainImage = q('[data-bp-main-image]');
    var kitSource = mainImage && mainImage.getAttribute('src'), activeView = 0, views = [], photoURL = null;
    var form = q('[data-bp-form]'), add = q('[data-bp-add]'), buyNow = q('[data-bp-buy-now]'), photo = q('[data-bp-photo]');
    var story = q('[data-bp-story-choice]'), fixedStory = String(cfg.id) === '15430641713248' && cfg.fixedStory && cfg.fixedStory.id === 'potty' ? cfg.fixedStory : null, isComingSoon = !!cfg.comingSoon;
    function q(selector) { return root.querySelector(selector); }
    function qa(selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
    function L(value) { return value && typeof value === 'object' ? String(value[cfg.lang] || value.ar || value.en || '') : String(value || ''); }
    function digits(value) { return String(value || '').split('/').pop(); }
    function text(selector, value) { var node = q(selector); if (node) { node.textContent = value; node.hidden = !value; } }
    function element(tag, className, value) { var node = document.createElement(tag); if (className) node.className = className; if (value != null) node.textContent = value; return node; }
    function fmt(template, values) { return String(template || '').replace(/\{(\w+)\}/g, function (match, key) { return values[key] == null ? match : String(values[key]); }); }
    function money(cents) {
      var amount = Number(cents) / 100;
      if (cfg.currency === 'EGP') return amount.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ' ' + S.egp;
      try { return new Intl.NumberFormat(cfg.lang === 'en' ? 'en' : 'ar-EG', { style: 'currency', currency: cfg.currency }).format(amount); }
      catch (e) { return amount.toLocaleString('en-US') + ' ' + String(cfg.currency || ''); }
    }
    function asset(path) {
      if (typeof path !== 'string' || !path) return '';
      var value = (window.BABY_BUNDLE_ASSETS || {})[path] || path;
      if (/^assets\//.test(value)) return '';
      if (/^data:image\/(png|jpe?g|webp);base64,/i.test(value)) return value;
      try { var url = new URL(value, location.href); return /^https?:$/.test(url.protocol) ? url.href : ''; }
      catch (e) { return ''; }
    }
    function optionFor(v) {
      if (!p || !v) return null;
      return (p.options || []).find(function (o) { return digits(o.variantId) === String(v.id) || o.sku && o.sku === v.sku; }) || null;
    }
    function selectedVariant() {
      var selected = q('[name="id"]:checked') || q('[data-bp-single-variant]');
      return selected && variants.find(function (v) { return String(v.id) === String(selected.value); }) || null;
    }
    function components(v) {
      if (!p) return [];
      var opt = optionFor(v), keys = opt && opt.componentKeys || p.componentKeys || [];
      var originals = p.components || [], global = DATA.components || {};
      var media = opt && (DATA.optionComponentMedia || {})[opt.id] || {};
      return keys.map(function (key) {
        var c = originals.find(function (item) { return item.key === key; }) || global[key];
        return c ? Object.assign({}, c, media[key] || {}) : null;
      }).filter(Boolean);
    }
    function productURL(c) {
      if (!c.productUrl || c.localPreview) return '';
      try {
        var url = new URL(c.productUrl, location.href);
        if (url.protocol !== 'https:' || !/(^|\.)babyineg\.com$/i.test(url.hostname)) return '';
        if (!/^\/(?:en\/)?products\//.test(url.pathname)) return '';
        if (cfg.lang === 'en' && url.pathname.indexOf('/en/') !== 0) url.pathname = '/en' + url.pathname;
        return url.href;
      } catch (e) { return ''; }
    }
    function name(c) { return L({ ar: c.ar, en: c.en }); }
    function updatePrice(v) {
      var available = variants.filter(function (item) { return item.available; });
      var pool = available.length ? available : variants;
      var fallback = pool.slice().sort(function (a, b) { return a.price - b.price; })[0];
      var chosen = v || fallback;
      if (!chosen) return;
      var priceVaries = pool.some(function (item) { return item.price !== chosen.price; });
      var refsMatch = pool.every(function (item) { return item.compareAtPrice === chosen.compareAtPrice; });
      var gift = p && L(p.giftLine), reference = chosen.compareAtPrice;
      var showReference = !gift && reference > chosen.price && (v || !priceVaries && refsMatch);
      text('[data-bp-price-current]', (!v && priceVaries ? S.from + ' ' : '') + money(chosen.price));
      text('[data-bp-price-save]', showReference ? S.save + ' ' + money(reference - chosen.price) : '');
      text('[data-bp-price-was]', showReference ? money(reference) : '');
      q('[data-bp-price-old]').hidden = !showReference;
      text('[data-bp-gift]', gift);
      var unavailable = !cfg.available || !available.length || v && !v.available;
      add.disabled = !!(isComingSoon || unavailable);
      add.textContent = isComingSoon ? S.comingSoon : unavailable ? S.soldOut : S.add;
      if (buyNow) { buyNow.disabled = add.disabled; buyNow.textContent = isComingSoon ? S.comingSoon : unavailable ? S.soldOut : S.buyNow; }
    }
    function showView(index) {
      var view = views[index];
      if (!view || !mainImage) return;
      activeView = index; mainImage.src = view.src; mainImage.alt = view.label;
      mainImage.parentNode.classList.toggle('bp-main--component', index !== 0);
      qa('[data-bp-photo-index]').forEach(function (button) { button.setAttribute('aria-pressed', Number(button.dataset.bpPhotoIndex) === index ? 'true' : 'false'); });
      var caption = index ? view.label : '';
      if (view.key === 'story' || view.key === 'potty_story') caption += '. ' + (view.key === 'potty_story' && fixedStory ? S.pottyBookSample : S.bookSample);
      if (view.key === 'chair006') caption += '. ' + S.chairViews;
      text('[data-bp-caption]', caption);
    }
    function updateGallery(v) {
      views = [{ src: asset(p && p.image) || kitSource, label: p ? L(p.title) : mainImage.alt }];
      var liveMedia = (((window.BABY_BUNDLE_LIVE_DATA || {})[String(cfg.id)] || {}).m || []); if (liveMedia.length > 2) { liveMedia.slice(1, 8).forEach(function (u, i) { views.push({ src: u, label: (p ? L(p.title) : '') + ' ' + (i + 2) }); }); } else { components(v).forEach(function (c) { var src = asset(c.image); if (src) views.push({ src: src, label: name(c), key: c.key }); }); }
      var thumbs = q('[data-bp-thumbs]'); thumbs.replaceChildren();
      views.forEach(function (view, index) {
        var button = element('button', 'bp-thumb' + (index ? ' bp-thumb--component' : ''));
        button.type = 'button'; button.dataset.bpPhotoIndex = index;
        button.setAttribute('aria-label', index ? view.label : S.kitPhoto);
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
        var img = element('img'); img.src = view.src; img.alt = ''; img.width = 80; img.height = 80; img.loading = 'lazy';
        button.appendChild(img); button.addEventListener('click', function () { showView(index); }); thumbs.appendChild(button);
      });
      showView(0);
    }
    function updateContents(v) {
      var list = q('[data-bp-contents]'), comps = components(v); list.replaceChildren();
      comps.forEach(function (c) {
        var row = element('li', 'bp-component'), src = asset(c.image);
        if (src) { var img = element('img', 'bp-component-image'); img.src = src; img.alt = ''; img.width = 76; img.height = 76; img.loading = 'lazy'; row.appendChild(img); }
        var copy = element('div', 'bp-component-copy'), title = name(c);
        if (Number(c.quantity) > 1 && ['easy', 'hard'].indexOf(c.key) === -1) title += ' × ' + c.quantity;
        copy.appendChild(element('p', 'bp-component-name', title));
        var url = productURL(c);
        if (url) {
          var label = c.linkKind === 'parent-set' ? S.viewSet : S.viewProduct;
          var link = element('a', 'bp-component-link', label + ' ↗');
          link.href = url; link.target = '_blank'; link.rel = 'noopener noreferrer';
          link.setAttribute('aria-label', label + ': ' + name(c) + '. ' + S.newTab);
          copy.appendChild(link);
        }
        row.appendChild(copy); list.appendChild(row);
      });
      q('[data-bp-contents-section]').hidden = !comps.length;
    }
    function renderDescription(v) {
      if (!p) return;
      var mount = q('[data-bp-description]');
      var desc = element('div', 'bi-product-desc t4s-product-info__item'); desc.dataset.lang = cfg.lang;
      function block(number, title, id) {
        var box = element('div', 'bi-section'), head = element('div', 'bi-section-head'), h3 = element('h3', '', title);
        h3.id = id; box.setAttribute('aria-labelledby',id); head.append(element('span','bi-section-icon',number),h3); box.appendChild(head); return box;
      }
      var hero = element('div', 'bi-hero-box'), badge = element('div', 'bi-hero-badge', p.modelLine ? L(p.modelLine) : 'Baby In Bundles');
      hero.append(badge, element('h2','',L(p.title))); if(p.intro)hero.appendChild(element('p','',L(p.intro))); desc.appendChild(hero);
      var why = block('01',S.benefits,'bp-why-title'), copy = element('div','bi-why-text');
      (p.benefits||[]).forEach(function(value){copy.appendChild(element('p','',L(value)));});
      var detail=L(p.detailNote); if(detail && detail!==L(p.selectionNote))copy.appendChild(element('p','',detail));why.appendChild(copy);desc.appendChild(why);
      var contentsBlock=block('02',S.contents,'bp-contents-title');contentsBlock.classList.add('bi-bundle-contents');contentsBlock.dataset.bpContentsSection='';
      var list=element('ul','bp-contents');list.dataset.bpContents='';contentsBlock.appendChild(list);desc.appendChild(contentsBlock);
      var faq=block('03',S.faqTitle,'bp-faq-title'), comp=components(v);
      var entries=[[S.faqInside,comp.map(function(c){return name(c)+(Number(c.quantity)>1&&['easy','hard'].indexOf(c.key)===-1?' × '+c.quantity:'');}).join('، ')]];
      var note=L(p.selectionNote);if(variants.length>1&&note)entries.push([S.faqChoice,note]);if(cfg.personalized)entries.push([S.faqStory,fixedStory?S.faqPottyStoryAnswer:S.faqStoryAnswer]);
      (p.faq&&p.faq.length?[]:entries.slice(1,3)).concat((p.faq||[]).map(function(e){return [e.q,e.a];})).forEach(function(qa){var item=element('details','bi-faq-item'),summary=element('summary'),answer=element('div','bi-faq-answer');summary.appendChild(element('strong','',qa[0]));answer.appendChild(element('p','',qa[1]));item.append(summary,answer);faq.appendChild(item);});if(faq.querySelector('.bi-faq-item'))desc.appendChild(faq);
      mount.replaceChildren(desc);updateContents(v);
    }
    function refreshVariant() {
      var v=selectedVariant(),opt=optionFor(v);updatePrice(v);
      if(p){updateGallery(v);renderDescription(v);}text('[data-bp-choice-label]',opt?': '+L(opt.label):'');text('[data-bp-form-error]','');
    }
    if (p) {
      text('[data-bp-title]', L(p.title));text('[data-bp-selection-note]',L(p.selectionNote));
      qa('[data-bp-variant]').forEach(function(input){
        var v=variants.find(function(item){return String(item.id)===input.value;}),opt=optionFor(v),label=input.closest('.bp-variant');
        if(!opt)return;label.querySelector('[data-bp-variant-label]').textContent=L(opt.label);
      });
    }
    qa('[data-bp-variant]').forEach(function (input) {
      input.addEventListener('change', function () {
        refreshVariant();
        try { var url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState(null, '', url.href); } catch (e) { }
      });
    });
    function validatePhoto() {
      if (!photo) return true;
      var file = photo.files && photo.files[0], error = '';
      if (file && !(['image/jpeg', 'image/png', 'image/webp'].indexOf(file.type) !== -1 || !file.type && /\.(jpe?g|png|webp)$/i.test(file.name))) error = S.photoType;
      if (file && file.size > 10 * 1024 * 1024) error = S.photoSize;
      photo.setCustomValidity(error); text('[data-bp-photo-error]', error);
      return !error;
    }
    function childGender() { var selected = q('[data-bp-gender]:checked'); return selected ? selected.dataset.bpGender : ''; }
    function storySelection(gender) {
      if (fixedStory) return { template: fixedStory.id + '-' + gender, title: fixedStory.title, fixed: true };
      var chosen = story && story.options[story.selectedIndex];
      return { template: chosen && chosen.dataset.template, title: chosen && chosen.textContent, fixed: false };
    }
    function updateSummary() {
      if (!cfg.personalized) return;
      var input = q('[data-bp-child-name]'), value = input && input.value.trim();
      text('[data-bp-child-summary]', value ? fmt(S.childSummary, { name: value }) : '');
    }
    function updateStory() {
      if (!story) return;
      var gender = childGender(), selected = story.options[story.selectedIndex];
      story.disabled = !gender;
      Array.prototype.forEach.call(story.options, function (option) {
        if (!option.dataset.template) return;
        option.disabled = !gender || option.dataset.gender !== gender; option.hidden = !!gender && option.dataset.gender !== gender;
      });
      if (selected && selected.dataset.template && selected.dataset.gender !== gender) story.selectedIndex = 0;
      selected = story.options[story.selectedIndex];
      var cover = q('[data-bp-story-cover]');
      var template = (cfg.templates || []).find(function (item) { return selected && item.id === selected.dataset.template; });
      cover.hidden = !template;
      if (template) { cover.src = template.src; cover.alt = template.title; }
    }
    if (photo) photo.addEventListener('change', function () {
      var valid = validatePhoto(), preview = q('[data-bp-photo-preview]');
      if (photoURL) URL.revokeObjectURL(photoURL);
      photoURL = null; preview.hidden = true; preview.removeAttribute('src');
      if (valid && photo.files && photo.files[0]) { photoURL = URL.createObjectURL(photo.files[0]); preview.src = photoURL; preview.hidden = false; }
    });
    qa('[data-bp-gender]').forEach(function (input) { input.addEventListener('change', function () { updateStory(); updateSummary(); }); });
    if (story) story.addEventListener('change', updateStory);
    var childName = q('[data-bp-child-name]'); if (childName) childName.addEventListener('input', updateSummary);
    function addProperty(container, key, value) { var input = element('input'); input.type = 'hidden'; input.name = 'properties[' + key + ']'; input.value = value; container.appendChild(input); }
    form.addEventListener('submit', function (event) {
      event.preventDefault(); event.stopImmediatePropagation();
      var v = selectedVariant();
      if (isComingSoon || !cfg.available || !v || !v.available) {
        event.preventDefault(); text('[data-bp-form-error]', isComingSoon ? S.comingSoon : !v ? S.chooseVariant : S.soldOut); return;
      }
      if (!validatePhoto() || !form.reportValidity()) { event.preventDefault(); return; }
      var props = q('[data-bp-order-properties]'); props.replaceChildren();
      if (cfg.personalized) {
        var gender = childGender(), selection = storySelection(gender), templateId = selection.template;
        if (!templateId || !gender || !selection.fixed && templateId.charAt(0) !== gender || !photo || !photo.files.length) { event.preventDefault(); form.reportValidity(); return; }
        var child = { n: 1, name: childName.value.trim().replace(/\s+/g, ' '), age: Number(q('[data-bp-child-age]').value), gender: gender };
        var number = cfg.lang === 'en' ? '1' : '١';
        var genderText = q('[data-bp-gender]:checked').value;
        addProperty(props, S.propPack, S.packOne);
        addProperty(props, fmt(S.propStory, { n: number }), fmt(S.storyValue, { title: selection.title, name: child.name, n: number }));
        addProperty(props, fmt(S.propChild, { n: number }), fmt(S.childValue, { name: child.name, gender: genderText, age: child.age }));
        addProperty(props, '_bip_order', JSON.stringify({ v: 1, count: 1, stories: [{ template: templateId, child: 1 }], children: [child] }));
        if (selection.fixed) { addProperty(props, '_bi_story_type', fixedStory.id); addProperty(props, '_bi_story_template', templateId); }
      }
      addProperty(props, '_bi_bundle_variant', String(v.sku || v.id));
      add.disabled = true; add.textContent = S.adding;
      var ret=q('[data-bp-return]');if(ret){var cartUrl=ret.dataset.bpCartUrl||'/cart';ret.value=event.submitter===buyNow?cartUrl.replace(/cart\/?$/,'checkout'):cartUrl;}
      if(buyNow)buyNow.disabled=true;
      HTMLFormElement.prototype.submit.call(form);
    });
    var qty=q('[data-bp-quantity]');
    function quantity(delta){if(qty)qty.value=String(Math.max(1,Math.min(99,(parseInt(qty.value,10)||1)+delta)));}
    q('[data-bp-qty-minus]').addEventListener('click',function(){quantity(-1);});q('[data-bp-qty-plus]').addEventListener('click',function(){quantity(1);});
    q('[data-bp-gallery-prev]').addEventListener('click',function(){showView((activeView-1+views.length)%views.length);});q('[data-bp-gallery-next]').addEventListener('click',function(){showView((activeView+1)%views.length);});
    var customize=q('[data-bp-customize]');if(customize)customize.addEventListener('click',function(){var child=q('[data-bp-child-name]');child.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});child.focus({preventScroll:true});});
    refreshVariant(); updateStory();
    window.addEventListener('pageshow', function () { updatePrice(selectedVariant()); });
    window.addEventListener('pagehide', function (event) { if (!event.persisted && photoURL) URL.revokeObjectURL(photoURL); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
